<h2 mat-dialog-title *ngIf="isExistingUseLabel">Edit Uses {{data?.usesName}}</h2>
<h2 mat-dialog-title *ngIf="!isExistingUseLabel">Create Use Label</h2>
<div class="content flex column align-center">
    <mat-form-field class="full-width-field">
        <mat-label>Select Global Use</mat-label>
        <mat-select [(value)]="selectedUseType">
            <ng-container *ngFor="let uses of usesTypes">
                <mat-option [value]="uses">
                    {{uses.Name}}
                </mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="full-width-field">
        <input matInput placeholder="Type Use name:" [(ngModel)]="currentUse.Label"
            (ngModelChange)="checkValidation($event)">
    </mat-form-field>


    <mat-form-field class="full-width-field">
        <mat-label>Select Use Class</mat-label>
        <mat-select placeholder="Select" [(ngModel)]='currentUse.ClassId'>
            <mat-option *ngFor="let useClass of useClassOptions" [value]="useClass.Id">{{useClass.Label}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <span *ngIf="importErrors" class="errors-labels"> {{importErrors}} </span>
    <span *ngIf="!importErrors" class="errors-labels">&nbsp;</span>

</div>

<mat-dialog-actions class="flex end">
    <button mat-raised-button class="action" [disabled]="!validLabelName || !selectedUseType"
        (click)="changeUses()">Save</button>
    <button mat-raised-button mat-dialog-close cdkFocusInitial>Cancel</button>
</mat-dialog-actions>
